import { render } from "./DemoTile.vue?vue&type=template&id=7cf8e986&scoped=true"
import script from "./DemoTile.vue?vue&type=script&lang=js"
export * from "./DemoTile.vue?vue&type=script&lang=js"

import "./DemoTile.vue?vue&type=style&index=0&id=7cf8e986&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf8e986"]])

export default __exports__